import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function FullStackEngineer() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const position = {
    title: 'Full Stack Engineer',
    department: 'Engineering',
    location: 'Worldwide (Remote)',
    type: 'Full-Time',
    salaryRange: '$1,000-$2,000 USD',
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <Link
            to="/careers"
            className="text-[#0049ac] hover:text-[#0049ac]/90 flex items-center"
          >
            ← Back to Careers
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="p-8">
                <div className="mb-8">
                  <h1 className="text-3xl font-bold text-gray-900 mb-4">{position.title}</h1>
                  <div className="flex items-center gap-2 mb-6">
                    <p className="text-gray-500">{position.department} • {position.location} • {position.type}</p>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      {position.salaryRange}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                      Full Remote
                    </span>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                      SellAbroad
                    </span>
                  </div>
                </div>

                <div className="prose max-w-none">
                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">About SellAbroad</h2>
                    <p>
                      SellAbroad empowers international e-commerce brands to expand into the MENA market by streamlining cross-border logistics, integrating local payment methods, and leveraging AI sales tools. We build robust, scalable, and secure e-commerce applications that drive global success.
                    </p>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Job Description</h2>
                    <p>
                      We are seeking a highly skilled Fullstack Team Lead to join our innovative team. In this role, you will be responsible for leading and managing a team of developers while driving both frontend and backend development. You will design responsive user interfaces using JavaScript, React, Tailwind CSS, and TypeScript, and develop robust backend services with Node.js. You will work in an agile environment, overseeing the development of microservices-based architectures that power our platform. Your leadership will ensure that projects are delivered on time, meet high quality standards, and align with our business objectives. Experience managing teams and coordinating multiple developers is a must.
                    </p>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Key Responsibilities</h2>
                    <ul className="list-disc pl-5 space-y-6">
                      <li>
                        <h3 className="font-medium mb-2 inline-block">Team Leadership</h3>
                        <ul className="list-disc pl-5 mt-2">
                          <li>Provide technical guidance and mentorship to the development team, overseeing daily operations and project delivery.</li>
                        </ul>
                      </li>

                      <li>
                        <h3 className="font-medium mb-2 inline-block">Architecture & Development</h3>
                        <ul className="list-disc pl-5 mt-2">
                          <li>Lead the design, development, and maintenance of microservices-based architectures that ensure scalability, resilience, and security.</li>
                          <li>Develop responsive user interfaces and robust backend services in alignment with our technical roadmap.</li>
                        </ul>
                      </li>

                      <li>
                        <h3 className="font-medium mb-2 inline-block">Agile Practices</h3>
                        <ul className="list-disc pl-5 mt-2">
                          <li>Work within an agile framework, participating in daily stand-ups, sprint planning, retrospectives, and code reviews to drive continuous improvement.</li>
                        </ul>
                      </li>

                      <li>
                        <h3 className="font-medium mb-2 inline-block">Cross-functional Collaboration</h3>
                        <ul className="list-disc pl-5 mt-2">
                          <li>Coordinate with cross-functional teams to translate business requirements into scalable and efficient solutions.</li>
                        </ul>
                      </li>

                      <li>
                        <h3 className="font-medium mb-2 inline-block">Integration & Implementation</h3>
                        <ul className="list-disc pl-5 mt-2">
                          <li>Ensure seamless integration with third-party services such as e-commerce platforms (e.g., Shopify), payment systems, logistics providers, and partner APIs.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">Qualifications</h2>
                    <ul className="list-disc pl-5">
                      <li>Minimum 5 years of fullstack development experience with a proven track record in managing and leading development teams.</li>
                      <li>Strong proficiency in frontend technologies including JavaScript, React, Tailwind CSS, and TypeScript.</li>
                      <li>Expertise in backend development using Node.js, with hands-on experience in building and managing microservices architectures.</li>
                      <li>Extensive experience working in agile environments, with a deep understanding of agile methodologies and best practices.</li>
                      <li>Proficiency with RESTful APIs, database design (SQL and/or NoSQL), and CI/CD pipelines.</li>
                      <li>Excellent problem-solving skills, strong communication abilities, and a passion for fostering a collaborative environment.</li>
                      <li>Bachelor's degree in Computer Science, Engineering, or a related field, or equivalent practical experience.</li>
                    </ul>
                  </div>

                  <div className="mb-8">
                    <h2 className="text-xl font-semibold mb-4">What We Offer</h2>
                    <ul className="list-disc pl-5">
                      <li>Fully remote work environment with the flexibility to work from anywhere.</li>
                      <li>A pioneering team driving e-commerce innovation in the MENA market.</li>
                      <li>A collaborative, innovative, and growth-focused work environment.</li>
                      <li>Competitive salary and benefits package.</li>
                      <li>Opportunities for professional development and career advancement.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Floating apply card */}
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <div className="bg-white rounded-lg shadow-xl p-6">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">Apply for this Position</h2>
                <p className="text-gray-600 mb-6">
                  Join our team and help transform e-commerce in the MENA region.
                </p>
                <Link
                  to="/careers/full-stack-software-engineer/apply"
                  className="w-full flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#0049ac] hover:bg-[#0049ac]/90 transition-all duration-200"
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FullStackEngineer; 